import { PlatformSiteAri } from '@atlassian/ari';

import { ActivitiesObjectType as ActivitiesObjectTypeV3 } from '../homeViewsQueryHelpers';

import type { ActivitiesObjectType } from './__types__/HomeRecentWorkQuery';
import { HomeRecentWorkQuery, HomeRecentWorkV3Query } from './HomeRecentWorkQuery.graphql';

export const getRecentWorkQueryOptions = ({
	cloudId,
	isLoggedIn,
	isWhiteboardViewedEnabled = false,
	isDatabaseEnabled = false,
	first = 10,
	isActivityV3MigrationEnabled = false,
}: {
	cloudId: string;
	isLoggedIn: boolean;
	isWhiteboardViewedEnabled?: boolean;
	isDatabaseEnabled?: boolean;
	first?: number;
	isActivityV3MigrationEnabled: boolean;
}) => ({
	query: isActivityV3MigrationEnabled ? HomeRecentWorkV3Query : HomeRecentWorkQuery,
	variables: {
		cloudId: isActivityV3MigrationEnabled
			? PlatformSiteAri.create({ siteId: cloudId }).toString()
			: cloudId,
		first,
		after: '',
		objectTypes: [
			ActivitiesObjectTypeV3.PAGE,
			ActivitiesObjectTypeV3.BLOGPOST,
			ActivitiesObjectTypeV3.EMBED,
			...(isWhiteboardViewedEnabled ? [ActivitiesObjectTypeV3.WHITEBOARD] : []),
			...(isDatabaseEnabled ? [ActivitiesObjectTypeV3.DATABASE] : []),
			...(isActivityV3MigrationEnabled ? [ActivitiesObjectTypeV3.CONTENT] : []),
		] as ActivitiesObjectType[] | null,
	},
	skip: !isLoggedIn,
});
